import React, { Component } from 'react';
import style from './Memorabilia.module.css';
import $ from "jquery";
import history_img from '../../images/history.png';
import {Timeline} from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';

import { getHistory } from "./service";

class Memorabilia extends Component {

    state = {
        historyData: []
    };

    constructor(props) {
        super(props);
        this.onJWMemorabiliaDivScroll = this.onJWMemorabiliaDivScroll.bind(this);
    }


    componentDidMount = async () => {
        const { data } = await getHistory();
        if(data!=null){
            this.setState({ historyData: data.list });
        }
        window.addEventListener('scroll', this.onJWMemorabiliaDivScroll);
    };

    onJWMemorabiliaDivScroll=()=>{
        let msg = $(".history_img");
        let item = $("#history_L");
        let items = $("#history_R");
        let windowHeight = $(window).height();
        let Scroll = $(document).scrollTop();

        if(msg.offset() && (msg.offset().top - Scroll -windowHeight) <= 0) {
            msg.fadeIn(1500);
        }
        for(let i = 0; i < item.length; i++){
            if(($(item[i]).offset().top - Scroll - windowHeight)<= -100){
                $(item[i]).animate({marginRight:'0px'},'50','swing');
            }
        }
        for(let i = 0; i < items.length; i++){
            if(($(items[i]).offset().top - Scroll - windowHeight)<= -100){
                $(items[i]).animate({marginLeft:'0px'},'50','swing');
            }
        }
    }



    render() {
        const { historyData } = this.state;
        let historyLeftData=[];
        let historyRightData=[];
        let viewHistoryData=[];
        if(historyData.length !== 0){
            historyData.sort((item1,item2)=>{
                return item1.history_date<item2.history_date?1:-1;
            })
            historyData.reverse();
            console.log(historyData);
            historyData.map((item,index)=>{
                let historyDate = item.history_date.split('T')[0];
                let obj={key:index,history_year:historyDate.split('-')[0],history_month:historyDate.split('-')[1],history_text:item.content}
                if((index+1)%2 === 0){
                    historyLeftData.push(obj)
                }else{
                    historyRightData.push(obj)
                }
            });
        }


        let leftHistory=historyLeftData.map(({key,history_year,history_month,history_text},index)=>{
            return(
                <Timeline.Item key={key} id="history_L" className={style.leftItemDivSty}>
                    <span className={style.leftItemYeaySty} style={{color:index>=3 && index <6?`rgb(55, 119, 157)`:index>=6?`rgb(247, 109, 2)`:`rgb(212, 52, 52)`}}>{history_year}</span>
                    <div className={style.pointerDiv}>
                        <div className={style.lineSty}/>
                        <div className={style.pointSty}/>
                    </div>
                    <b className={style.leftItemTextDiv} style={{backgroundColor:index>=3 && index <6?`rgb(55, 119, 157)`:index>=6?`rgb(247, 109, 2)`:`rgb(212, 52, 52)`}}>
                        <span className={style.leftItemMonthSty} style={{backgroundColor:index>=3 && index <6?`rgb(55, 119, 157)`:index>=6?`rgb(247, 109, 2)`:`rgb(212, 52, 52)`}}>{history_month}<br/>月</span>
                        <span className={style.leftItemSJSty}>{history_text}</span>
                    </b>
                </Timeline.Item>
            )
        });

        let rightHistory=historyRightData.map(({key,history_year,history_month,history_text},index)=>{

            return(
                <Timeline.Item key={key} id="history_R" className={style.leftItemDivSty} style={{flexDirection:'row',marginTop:index==0?'90px':'30px'}}>
                    <span className={style.leftItemYeaySty} style={{color:index>=4 && index <7?`rgb(55, 119, 157)`:index>=6?`rgb(247, 109, 2)`:`rgb(212, 52, 52)`}}>{history_year}</span>
                    <div className={style.pointerDiv}>
                        <div className={style.lineSty}/>
                        <div className={style.pointSty}/>
                    </div>
                    <b className={style.leftItemTextDiv} style={{flexDirection:'row',backgroundColor:index>=4 && index <7?`rgb(55, 119, 157)`:index>=6?`rgb(247, 109, 2)`:`rgb(212, 52, 52)`}} >
                        <span className={style.leftItemMonthSty} style={{borderRight:'1px solid #FFF',backgroundColor:index>=4 && index <7?`rgb(55, 119, 157)`:index>=6?`rgb(247, 109, 2)`:`rgb(212, 52, 52)`}}>{history_month}<br/>月</span>
                        <span className={style.leftItemSJSty}>{history_text}</span>
                    </b>
                </Timeline.Item>
            )

        });

        if(historyData.length!=0){
            historyData.map((item,index)=>{
                let historyDate = item.history_date.split('T')[0];
                let obj={key:index,history_year:historyDate.split('-')[0],history_month:historyDate.split('-')[1],history_text:item.content}
                viewHistoryData.push(obj);
            });
        }

        let viewHistory=viewHistoryData.map(({key,history_year,history_month,history_text},index)=>{
            let direction="";
            if(index%2 === 0){
                direction="row"
            }else{
                direction="row-reverse"
            }
            return(
                <Timeline.Item key={key} id={index} dot={<ClockCircleOutlined className="timeline-clock-icon" size="20"/> } color="red">
                    <div className={style.leftItemDivSty} style={{flexDirection:direction}}>
                        <span className={style.leftItemYeaySty} style={{color:`rgb(212, 52, 52)`}}>{history_year}</span>
                        <div className={style.pointerDiv}>
                            <div className={style.lineSty}/>
                            <div className={style.pointSty}/>
                        </div>
                        <b className={style.leftItemTextDiv} style={{display: 'flex',flexDirection:direction,backgroundColor:`rgb(212, 52, 52)`}} >
                            {/* <span className={style.leftItemMonthSty} style={{borderRight:'1px solid #FFF',backgroundColor:`rgb(212, 52, 52)`}}>{history_month}<br/>月</span> */}
                            <span className={style.leftItemSJSty}>{history_text}</span>
                        </b>
                    </div>
                </Timeline.Item>
            )
        })



        return(
            <div className={style.pageSty}>
                <div className={[`${style.wrapper}`].join(' ')} onScrollCapture={this.onJWMemorabiliaDivScroll()}>
                    <div className={[`${style.history}`].join(' ')} style={{width:904}}>
                        <div className={[`${style.start_history}`].join(' ')}>
                            <p className={[`${style.cc_history}`].join(' ')}>经纬大事记</p>
                            {/* <p className={[`${style.next_history}`].join(' ')}>PHYLOGENY</p> */}
                            {/* <div className={[`${style.history_left}`].join(' ')}>
                                {leftHistory}
                            </div>

                            <div className={[`${style.history_img}`, 'history_img'].join(' ')}>
                                <img className={[`${style.history_img}`].join(' ')} src={history_img} alt=""/>
                            </div>

                            <div className={[`${style.history_right}`].join(' ')}>
                                {rightHistory}
                            </div>
                            <div className={[`${style.clear}`].join(' ')}/> */}
                            <div style={{display: 'flex',flexDirection: 'column',justifyContent:'center',alignItems:'center'}}>
                                <Timeline className={style.tlStyle} mode="alternate">
                                    {viewHistory}
                                </Timeline>
                            </div>
                        </div>
                        
                        <div className={[`${style.clear}`].join(' ')}/>
                    </div>
                </div>
            </div>
        )
    };
}

export default Memorabilia;
